/* src/app/system-utils/carousel/carousel.component.scss */
.carousel {
  width: 100%;
  position: relative;
  overflow: hidden;
  outline: none;
}
.carousel > button {
  position: absolute;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
}
.carousel > button:first-of-type {
  left: 30px;
}
.carousel > button:last-of-type {
  right: 30px;
}
.carousel-list {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
.carousel-slide {
  width: 100%;
  height: 0;
  display: flex;
  flex-shrink: 0;
  position: relative;
}
.carousel-slide:hover {
  cursor: grab;
}
.carousel-indicators {
  display: flex;
  position: absolute;
  bottom: 15px;
  z-index: 1;
  left: 50%;
  transform: translateX(-50%);
  outline: none;
}
.carousel-indicators > button {
  width: 10px !important;
  height: 10px !important;
  margin: 7.5px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: var(--tem-muted);
  opacity: 0.5;
  cursor: pointer;
}
.carousel-indicators > button.carousel-indicator-active {
  background: var(--tem-accent);
  opacity: 1;
  cursor: default;
}
/*# sourceMappingURL=carousel.component.css.map */
